'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import classes from './style.module.scss';

import breakpoints from '@/lib/breakpoints';
import { cn } from '@/lib/utils';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import ButtonLink from '../links/ButtonLink';
import NextImage from '../NextImage';
import SectionTitle from '../SectionTitle';

type SectionMorePartner = {
  becomepartner: {
    sectiontitle: string;
    ctaurl: string;
    sectionimage: {
      altText: string;
      sourceUrl: string;
    };
  };
};

export default function SectionMorePartner(props: SectionMorePartner) {
  const { becomepartner } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return (
    <div className='section-more__becomepartner md:w-12/12 mx-auto grid gap-16 pt-16 text-center md:grid-cols-2 md:gap-0 md:pt-20 md:text-left lg:pt-24'>
      <div className='flex flex-col items-center md:items-end md:gap-14 md:pr-0 md:pt-32 lg:pr-14'>
        {becomepartner?.sectiontitle && (
          <h3 className='h2 text-right'>
            <SectionTitle
              text={becomepartner.sectiontitle}
              align={desktop ? 'right' : 'center'}
              anchor='.section-more__becomepartner'
            />
          </h3>
        )}
        {desktop && becomepartner?.ctaurl && (
          <ButtonLink
            href={`mailto:${becomepartner.ctaurl}`}
            className='whitespace-nowrap'
            variant='outline'
            size='xl'
            data-aos='fade-in'
            data-aos-anchor='.section-more__becomepartner'
            data-aos-delay='600'
          >
            Contact us
          </ButtonLink>
        )}
      </div>
      {becomepartner?.sectionimage && (
        <div
          className='flex flex-col items-center gap-12 overflow-hidden rounded-lg md:ml-12 md:pl-12 xl:ml-0 xl:items-start'
          data-aos='fade-in'
          data-aos-anchor='.section-more__becomepartner'
          data-aos-delay='600'
        >
          <div
            className={cn(
              'relative h-72 w-72 overflow-hidden rounded-lg sm:h-[340px] sm:w-[340px] md:h-[607px] md:w-[607px]',
              classes.image,
            )}
          >
            <NextImage
              alt={becomepartner.sectionimage.altText}
              src={becomepartner.sectionimage.sourceUrl}
              className='h-full w-full object-cover object-center'
              width='607'
              height='607'
              sizes='(max-width: 640px) 100vw, (max-width: 768px) 50vw, 607px'
            />
          </div>
          {!desktop && becomepartner?.ctaurl && (
            <ButtonLink
              href={`mailto:${becomepartner.ctaurl}`}
              className='w-full whitespace-nowrap py-6'
              variant='outline'
              size='xl'
              data-aos='fade-in'
              data-aos-anchor='.section-more__becomepartner'
              data-aos-delay='600'
            >
              Contact us
            </ButtonLink>
          )}
        </div>
      )}
    </div>
  );
}
